import { restaurantStatusSchema } from "@luckymenu/core";
import { createFileRoute } from "@tanstack/react-router";
import { type ListSearch, RestaurantListPage } from "../../features/restaurants/list-page";

export const Route = createFileRoute("/restaurants/")({
	validateSearch: (search: Record<string, unknown>): ListSearch => {
		const status = restaurantStatusSchema.safeParse(search.status);
		const q = typeof search.q === "string" && search.q.trim() ? search.q.trim() : undefined;
		return { ...(q ? { q } : {}), ...(status.success ? { status: status.data } : {}) };
	},
	component: Page,
});

function Page() {
	return <RestaurantListPage search={Route.useSearch()} />;
}
